export class PermissionLevel { 
    Level: number;
    Name: string;
}

export enum PermissionLevelEnum{
    ServerAdministrator=5,
    Administrator=4,
    Supervisor=2,
    Standard=1, 
    Guest=0,
    Locked=-1
}